import CompanyGalleryWidget from '@/components/gallery/CompanyGalleryWidget';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';
import {
  createCompanyGallery,
  deleteCompanyGalleryImage,
  uploadCompanyGalleryImage,
} from '@/redux/actions/company';
import { getCompany as getCompanySelector } from '@/redux/selectors/companySelectors';
import { Box, Button, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

const CompanyAdminGallery: React.FC = () => {
  const dispatch = useAppDispatch();
  const company = useAppSelector(getCompanySelector);
  const { companyId } = useParams();

  const galleryImages =
    company?.gallery
      ?.slice()
      .sort((a, b) => a.position - b.position)
      .map((item) => item.urlImg) || [];

  const hasGallery = !!company?.cincopaFid;

  const handleCreateGallery = useCallback(() => {
    if (!companyId) return;

    dispatch(createCompanyGallery(Number(companyId)));
  }, [dispatch, companyId]);

  const handleUploadGalleryImage = useCallback(
    (index: number, file: File) => {
      if (!companyId) return;

      const position = index + 1;

      dispatch(
        uploadCompanyGalleryImage({
          companyId: Number(companyId),
          position,
          file,
        })
      );
    },
    [dispatch, companyId]
  );

  const handleDeleteGalleryImage = useCallback(
    (index: number) => {
      if (!companyId) return;

      const position = index + 1;

      dispatch(
        deleteCompanyGalleryImage({
          companyId: Number(companyId),
          position,
        })
      );
    },
    [dispatch, companyId]
  );

  if (!company) {
    return null;
  }

  return hasGallery ? (
    <>
      <Typography
        variant="h2"
        my={5}
        noWrap={true}
        textAlign="center"
      >
        Photo Gallery Upload
      </Typography>
      <CompanyGalleryWidget
        images={galleryImages}
        withActions
        onUploadImage={handleUploadGalleryImage}
        onDeleteImage={handleDeleteGalleryImage}
      />
    </>
  ) : (
    <Box display="flex" justifyContent="center" my={5}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleCreateGallery}
      >
        Add Gallery
      </Button>
    </Box>
  );
};

export default CompanyAdminGallery;

